"use client";

import { getPriceOptions } from "./_constants";
import { FC, useMemo } from "react";
import { useTranslations } from "next-intl";
import RangeFilter from "@/components/ui/RangeFilter";

interface PriceFilterProps {
  onFromPriceChange: (value: { value: number; label: string } | null) => void;
  onToPriceChange: (value: { value: number; label: string } | null) => void;
  onFromPriceClear: () => void;
  onToPriceClear: () => void;
  onReset: () => void;
  fromValue?: { value: number; label: string } | null;
  toValue?: { value: number; label: string } | null;
}

const PriceFilter: FC<PriceFilterProps> = ({
  onFromPriceChange,
  onToPriceChange,
  onFromPriceClear,
  onToPriceClear,
  onReset,
  fromValue,
  toValue,
}) => {
  const t = useTranslations("Filters");
  const priceOptions = useMemo(() => getPriceOptions(t), [t]);

  return (
    <RangeFilter
      onFromChange={onFromPriceChange}
      onToChange={onToPriceChange}
      options={priceOptions}
      label={t("price")}
      onFromClear={onFromPriceClear}
      onToClear={onToPriceClear}
      onReset={onReset}
      fromValue={fromValue}
      toValue={toValue}
    />
  );
};

export default PriceFilter;
